/**
 * 检测当前浏览器是否支持 Flexbox gap。
 * Safari 14.0 及更早版本虽然支持 Grid gap，但不支持 Flex gap，不能用 CSS.supports 判断。
 * @param {Document} targetDocument 浏览器文档对象
 * @returns {boolean} 是否支持 Flex gap
 */
const supportsFlexGap = targetDocument => {
    const flex = targetDocument.createElement('div');
    flex.style.display = 'flex';
    flex.style.flexDirection = 'column';
    flex.style.rowGap = '1px';

    flex.appendChild(targetDocument.createElement('div'));
    flex.appendChild(targetDocument.createElement('div'));
    targetDocument.body.appendChild(flex);

    const isSupported = flex.scrollHeight === 1;
    targetDocument.body.removeChild(flex);
    return isSupported;
};

/**
 * 为不支持 Flex gap 的旧版 Safari 添加 CSS 降级标记。
 * @param {Document} targetDocument 浏览器文档对象
 * @returns {boolean} 是否原生支持 Flex gap
 */
const installFlexGapFallback = targetDocument => {
    const isSupported = supportsFlexGap(targetDocument);
    if (!isSupported) {
        targetDocument.documentElement.classList.add('no-flex-gap');
    }
    return isSupported;
};

export {
    installFlexGapFallback,
    supportsFlexGap
};
